<template>
	<div>

		<div class="alert alert-info">
			<div class="text-center">
				<span class="f20 bold">{{theme.name}}</span>
			</div>
			<div>
				编号：{{theme.id}}
			</div>
			<div>
				名称：{{theme.name}}
			</div>
			<div class="">
				描述：{{theme.description}}
			</div>
			<div class="italic">
				以下为预览效果
			</div>
		</div>

		<slot></slot>

	</div>

</template>
<script>

	import {MessageBox, Notification} from 'element-ui'
	import Theme from "../../../../common/model/lover/Theme";

	export default {
		data () {
			return {}
		},
		components: {},
		props: {
			theme: {
				type: Theme,
				required: true
			}
		},
		computed: {},
		watch: {},
		methods: {},
		mounted(){

			this.id = parseInt(this.$store.state.route.params.id);

		}
	}

</script>



// WEBPACK FOOTER //
// DetailFrame.vue?0f490ed1